"use strict";
export var OnchainItemSectionName = /* @__PURE__ */ ((OnchainItemSectionName2) => {
  OnchainItemSectionName2["SearchResults"] = "searchResults";
  OnchainItemSectionName2["RecentSearches"] = "recentSearches";
  OnchainItemSectionName2["YourTokens"] = "yourTokens";
  OnchainItemSectionName2["TrendingTokens"] = "trendingTokens";
  OnchainItemSectionName2["FavoriteTokens"] = "favoriteTokens";
  OnchainItemSectionName2["SuggestedTokens"] = "suggestedTokens";
  OnchainItemSectionName2["BridgingTokens"] = "bridgingTokens";
  OnchainItemSectionName2["OtherChainsTokens"] = "otherNetworksTokens";
  OnchainItemSectionName2["Tokens"] = "tokens";
  OnchainItemSectionName2["Pools"] = "pools";
  OnchainItemSectionName2["TrendingPools"] = "trendingPools";
  OnchainItemSectionName2["Wallets"] = "wallets";
  OnchainItemSectionName2["FavoriteWallets"] = "favoriteWallets";
  OnchainItemSectionName2["NFTCollections"] = "nftCollections";
  OnchainItemSectionName2["PopularNFTCollections"] = "popularNFTCollections";
  return OnchainItemSectionName2;
})(OnchainItemSectionName || {});
